<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner rew19-contents-inner--wide">
      <h2 class="rew19-contents-title">나의 에이지락 미</h2>
      <div style="text-align: center; padding: 3% 7%;">
            <p style="font-weight:bold;">에이지락 미 리워드 프로그램이 2021년 6월 30일 종료됩니다</p>
            <a href="https://www.nuskinkorea.co.kr/app/board/cr/CustNoticeDetail?boardSeq=217903&boardWkCd=041" target="_blank"><p style="text-decoration: underline;">자세히 보기</p></a>
      </div>

      <div class="rew19_payment_list-total">총<strong>{{$fmt.PDCnt(viewData.master_list.length)}}</strong>개
      </div>

      <div class="rew19_payment_wrap">
        <table class="rew19-table-col">
          <caption>나의 에이지락 미</caption>
          <colgroup>
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th class="table-col__head">리워드 번호</th>
              <th class="table-col__head">
                수령인
                <span class="rew19_nextLine">(스킨케어 코드)</span>
              </th>
              <th class="table-col__head">결제일</th>
              <th class="table-col__head">상태</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item) in viewData.master_list" :key="item.adr_no"
              class="clickRow"
              @click="onClickItem(item)">              
              <td class="table-col__data">{{$nvl(item.adr_no, "-")}}</td>
              <td class="table-col__data">{{$nvl(item.ship_name, "-")}}
                <span class="rew19_nextLine">({{$nvl(item.agm_code, "-")}})</span>
              </td>
              <td class="table-col__data">{{$nvl(item.delivery_day, "-")}}</td>
              
              <!--grace or Mileage -->
              <td v-if='item.addpaymenttype == "G" || item.addpaymenttype == "M"'
                class="table-col__data"><!--grace or Mileage -->
                {{item.adr_cancel_date}}
                <span class="rew19_nextLine">
                  <a class="rew19_btn_intable active"
                    @click.stop.prevent="onClickRestore(item)"
                  >되살리기</a>
                </span>
              </td>
              <td v-else class="table-col__data">
                진행 <span class="rew19_point">{{$nvl(item.delivery_count, "-")}}</span>회차
              </td>
            </tr>            
            <tr v-if="!viewData.master_list || viewData.master_list.length <= 0">
              <td colspan="4" class="table-col__data no_data">에이지락 미 리워드 프로그램 참여내역이 없습니다.</td>
            </tr>
          </tbody>
        </table>
      </div>
      
    </div>
    <!--rew19_contents_inner-->
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

import DF from 'dateformat';

export default {
  name: "AgelocCurrentList",
  extends: AroBase,
  components: { },
  computed: {
     isNuskinChannel : function() {
       return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
     }
  },
  data() { 
    return {     
      //View Data     
      viewData : {
        master_list : [
          // {
          //   adr_no : "", //key
          // }
        ]
      },
      params : {      
        
      },

      testText : ""
    };
  },
  created() {
  },
  mounted() {
    let _this = this;

    _this.loadList(1);
  },
  methods: {    
    /**
     * JQuery UI
     */
    initUI(){
      
    },

    /**
     * API Request
     */
    //나의 에이지락 미 정보 가져오기
    apiGetAgelocme(pageNo){
      let _this = this;

      var reqStartDate = "2015-01-01"; //전체 리스트 다 가져오기
      var reqEndDate = DF(new Date(), "yyyy-mm-dd");
      
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_agelocme`, {
        params: {
          startDate: reqStartDate,
          endDate: reqEndDate,
        }
      });
    },

    //나의 에이지락 미 되살리기
    apiRestoreAgelocme(adr_no){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/restore_agelocme`, {
        params: {
          adr_no : adr_no,
        }
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadList(pageNo){
      let _this = this;

      //show loading
      _this.$showLoading();         
      _this.apiGetAgelocme(pageNo).then(res=>{
        
        if (res.status === 200 && res.data.status === "0000") {
          _this.viewData = {...res.data};

          // //Debuging code (되살리기 테스트)
          // if(_this.viewData.master_list && _this.viewData.master_list.length > 0){
          //   _this.viewData.master_list[0].addpaymenttype="G";
          // }
          
        }else{
          console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();          
      });
    },

    //상세 이동
    onClickItem(item){
      let _this = this;
      _this.$router.push(`${_this.$aroBasePath}/agelocCurrentDetail?adr_no=${item.adr_no}`);
    },

    //되살리기
    onClickRestore(item){
      let _this = this;

      const options = {cancelLabel: '취소', okLabel:'확인'};
      _this.$dialogs.confirm("되살리기를 진행 하시겠습니까?", options).then(res=>{
        if(res.ok){
          _this.doRestore(item);
        }
      });
    },

    //에이지락 미 되살리기
    doRestore(item){
      let _this = this;

      //show loading
      _this.$showLoading();      
      _this.apiRestoreAgelocme(item.adr_no).then(res=>{
        
        if (res.status === 200 && res.data.status === "0000") {
          _this.loadList(1);
          _this.$dialogs.alert("처리가 완료 되었습니다.", {okLabel:"확인"})
          .then(res => {});

        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    }
  }
}
</script>
<style>

tr.clickRow{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/my/ageloc/currentList.vue